'use client'
import {
  useConfig_default
} from "./chunk-H3RXJYUZ.mjs";

// src/hooks/useTranslation.ts
var useTranslation = (...args) => {
  return useConfig_default().i18n.useTranslation(...args);
};

export {
  useTranslation
};
//# sourceMappingURL=chunk-JDKPXTVA.mjs.map